module.exports = __webpack_public_path__ + "img/img_vip_08.9518e3ef.png";